module.exports = __webpack_public_path__ + "img/commitment.8f4c18dc.png";